import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmm { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '帳號代號 (MM001) 不可空白'}) 
    @MaxLength(6,{message: '帳號代號 (MM001) 資料太長'})
    MM001: string = '*';            // 帳號代號 6 [DEF:"*"] 單頭 STKMJ

    @IsNotEmpty({message: '條件代號 (MM002) 不可空白'}) 
    @MaxLength(6,{message: '條件代號 (MM002) 資料太長'})
    MM002: string = '';            // 條件代號 6 

    @IsNotEmpty({message: '股票代號 (MM003) 不可空白'}) 
    @MaxLength(10,{message: '股票代號 (MM003) 資料太長'})
    MM003: string = '';            // 股票代號 10 

    @IsNotEmpty({message: '更新日期 (MM004) 不可空白'}) 
    @MaxLength(8,{message: '更新日期 (MM004) 資料太長'})
    MM004: string = '';            // 更新日期 8 

    @MaxLength(8,{message: '更新時間 (MM005) 資料太長'})
    MM005: string = '';            // 更新時間 8 

    @MaxLength(1,{message: '選擇 (MM006) 資料太長'})
    MM006: string = 'N';            // 選擇 1 [DEF:"N"]

    @MaxLength(255,{message: '說明 (MM007) 資料太長'})
    MM007: string = '';            // 說明 255 


}
